<template>
  <section>
    <!-- 统计文字 -->
    <el-row class="statusRowWhite"  style="padding:15px;background:#fff">
				<div class="RowChild">
		      <el-date-picker
		      	class="xs24"
		        v-model="dateVal"
		        type="daterange"
		        range-separator="至"
		        start-placeholder="开始日期"
		        end-placeholder="今天"
		        format="yyyy 年 MM 月 dd 日"
		        value-format="yyyy-MM-dd"
		        :picker-options="pickerOptions"
		      ></el-date-picker>
	   		</div>
			  <div class="RowChild">
			  	<el-button type="primary" @click="exportIncome">导出</el-button>
			  </div>
			 	<div class="RowChild">
					&nbsp;平台来源： &nbsp;
					<el-select class="xs24" v-model="pdata.platform_id" placeholder="请选择小游戏来源" @change="changePlatform">
						<el-option :label="v.platform_name" :value="v.platform_id" v-for="(v,i) in get_issued_app_platform" :key="v.platform_id"></el-option>
					</el-select>
				</div>

      <!--<el-col :sm="8" :xs="24">
        <div style="float:right;text-align: right;">
          <el-row :gutter="10">
            <searchApp  class="xs24" @getid="changeId" compare="issued" :pholder="pholder"></searchApp>
          </el-row>
        </div>
      </el-col>-->
    </el-row>
    <el-table :data="list" style="width: 100%;min-width:1200px" stripe row-key="id"  show-summary :summary-method="getSummaries"  :height="height"  v-loading="loading"  element-loading-text="拼命加载中" element-loading-spinner="el-icon-loading" element-loading-background="rgba(0, 0, 0, 0.3)" :header-cell-class-name="getHeaderCellClassName" :cell-class-name="cellClassName">
    	<el-table-column prop="d_date" label="日期" align="center" ></el-table-column>

      <el-table-column prop="" label="虚拟结算" align="center" >		
      	<el-table-column prop="huanliang_in" label="换入量" align="center"  sortable   :sort-method="(a,b)=>{return (a.huanliang_in-0)-(b.huanliang_in-0)}">
      		  <template slot="header" slot-scope="scope">
			       		<el-tooltip class="item" effect="dark" content="量级*单价" placement="top-start">
						      <span>换入量</span>
						    </el-tooltip>
			      </template>
			      <template  slot-scope="scope">
			       		￥{{scope.row.huanliang_in}}
			    </template>
      	</el-table-column>
      	<el-table-column prop="huanliang_out" label="换出量" align="center"  sortable   :sort-method="(a,b)=>{return (a.huanliang_out-0)-(b.huanliang_out-0)}">
      			<template slot="header" slot-scope="scope">
			       		<el-tooltip class="item" effect="dark" content="量级*单价" placement="top-start">
						      <span>换出量</span>
						    </el-tooltip>
			      </template>
			      <template  slot-scope="scope">
			       		￥{{scope.row.huanliang_out}}
			      </template>
      	</el-table-column>
      	<el-table-column prop="matrix_buy_cost" label="矩阵买量" align="center"  min-width="110px"  sortable   :sort-method="(a,b)=>{return (a.matrix_buy_cost-0)-(b.matrix_buy_cost-0)}">
      		<template  slot-scope="scope">
			       		￥{{scope.row.matrix_buy_cost}}
			    </template>
      	</el-table-column>
      	<el-table-column prop="matrix_sell_income" label="矩阵卖量" align="center"  min-width="110px"  sortable   :sort-method="(a,b)=>{return (a.matrix_sell_income-0)-(b.matrix_sell_income-0)}">
      		<template  slot-scope="scope">
			       		￥{{scope.row.matrix_sell_income}}
			    </template>
      	</el-table-column>
      </el-table-column>
      
     <el-table-column prop="" label="现金结算" align="center" >
     		<el-table-column prop="origin_income" label="流量主" align="center"  min-width="100px"  sortable   :sort-method="(a,b)=>{return (a.origin_income-0)-(b.origin_income-0)}">
     			<template  slot-scope="scope">
			       		￥{{scope.row.origin_income}}
			    </template>
     		</el-table-column>
      	<el-table-column prop="origin_divide_income" label="流量主分成后" align="center"  min-width="120px"  sortable   :sort-method="(a,b)=>{return (a.origin_divide_income-0)-(b.origin_divide_income-0)}">
      		<template  slot-scope="scope">
			       		￥{{scope.row.origin_divide_income}}
			    </template>
      	</el-table-column>
      	<el-table-column prop="channel_sell_income" label="渠道卖量" align="center"  sortable min-width="100px"  :sort-method="(a,b)=>{return (a.channel_sell_income-0)-(b.channel_sell_income-0)}">
      		<template  slot-scope="scope">
			       		￥{{scope.row.channel_sell_income}}
			    </template>
      	</el-table-column>
      	<el-table-column prop="channel_buy_cost" label="渠道买量" align="center"  sortable min-width="100px"  :sort-method="(a,b)=>{return (a.channel_buy_cost-0)-(b.channel_buy_cost-0)}">
      		<template  slot-scope="scope">
			       		￥{{scope.row.channel_buy_cost}}
			    </template>
      	</el-table-column>
      	<el-table-column prop="gdt_buy_cost" label="广点通" align="center"  sortable min-width="100px"  :sort-method="(a,b)=>{return (a.gdt_buy_cost-0)-(b.gdt_buy_cost-0)}">
      		<template  slot-scope="scope">
			       		￥{{scope.row.gdt_buy_cost}}
			    </template>
      	</el-table-column>
     </el-table-column>
     
     <el-table-column prop="" label="合计（含矩阵）" align="center" >
     		<el-table-column prop="total_income_contain_matrix" label="收入" align="center" min-width="100px" sortable   :sort-method="(a,b)=>{return (a.total_income_contain_matrix-0)-(b.total_income_contain_matrix-0)}">
     			<template  slot-scope="scope">
			       		￥{{scope.row.total_income_contain_matrix}}
			    </template>
     		</el-table-column>
      	<el-table-column prop="total_cost_contain_matrix" label="成本" align="center" min-width="100px"  sortable   :sort-method="(a,b)=>{return (a.total_cost_contain_matrix-0)-(b.total_cost_contain_matrix-0)}">
      		<template slot="header" slot-scope="scope">
			       		<el-tooltip class="item" effect="dark" content="成本日报-实际花费" placement="top-start">
						      <span>成本</span>
						    </el-tooltip>
			    </template>
			    <template  slot-scope="scope">
			       		￥{{scope.row.total_cost_contain_matrix}}
			    </template>
      		
      	</el-table-column>
      	<el-table-column prop="total_profit_contain_matrix" label="利润" align="center" min-width="100px"  sortable   :sort-method="(a,b)=>{return (a.total_profit_contain_matrix-0)-(b.total_profit_contain_matrix-0)}" >
      		<template slot="header" slot-scope="scope">
			       		<el-tooltip class="item" effect="dark" content="收入合计-买量成本" placement="top-start">
						      <span>利润</span>
						    </el-tooltip>
			    </template>
      		<template slot-scope="scope">
			      	￥<span :class="scope.row.total_profit_contain_matrix>0?'':'red'">{{scope.row.total_profit_contain_matrix}}</span>
			  	</template>
      	</el-table-column>
     	</el-table-column>		
     
    	<el-table-column prop="" label="合计（不含矩阵）" align="center" >
     		<el-table-column prop="total_income_no_matrix" label="收入" align="center" min-width="100px"  sortable   :sort-method="(a,b)=>{return (a.total_income_no_matrix-0)-(b.total_income_no_matrix-0)}">
     			 <template  slot-scope="scope">
			       		￥{{scope.row.total_income_no_matrix}}
			    </template>
     		</el-table-column>
      	<el-table-column prop="total_cost_no_matrix" label="成本" align="center" min-width="100px"  sortable   :sort-method="(a,b)=>{return (a.total_cost_no_matrix-0)-(b.total_cost_no_matrix-0)}">
      		<template slot="header" slot-scope="scope">
			       		<el-tooltip class="item" effect="dark" content="成本日报-实际花费" placement="top-start">
						      <span>成本</span>
						    </el-tooltip>
			    </template>
			     <template  slot-scope="scope">
			       		￥{{scope.row.total_cost_no_matrix}}
			    </template>
      	</el-table-column>
      	<el-table-column prop="total_profit_no_matrix" label="利润" align="center" min-width="100px"  sortable   :sort-method="(a,b)=>{return (a.total_profit_no_matrix-0)-(b.total_profit_no_matrix-0)}">
      		<template slot="header" slot-scope="scope">
			       		<el-tooltip class="item" effect="dark" content="收入合计-买量成本" placement="top-start">
						      <span>利润</span>
						    </el-tooltip>
			    </template>
      		<template slot-scope="scope">
			      	￥<span :class="scope.row.total_profit_no_matrix>=0?'':'red'">{{scope.row.total_profit_no_matrix}}</span>
			  	</template>
      	</el-table-column>
     	</el-table-column>		
    	<el-table-column prop="" label="操作" align="center" >
    			<template slot-scope="scope">
			     <el-button size="mini" type="primary" @click="$router.push({name:'收入日报详情','query':{'sdate':scope.row.d_date.substring(0,4)+'-'+scope.row.d_date.substring(4,6)+'-'+scope.row.d_date.substring(6,8),'edate':scope.row.d_date.substring(0,4)+'-'+scope.row.d_date.substring(4,6)+'-'+scope.row.d_date.substring(6,8),platform_id:pdata.platform_id}})">详情</el-button>
			  	</template>
    		
    	</el-table-column>		

     <!-- <el-table-column prop="visit_uv_new_per" label="新增占比" align="center" ></el-table-column>-->
	  <!--	<el-table-column prop="origin_income" label="流量主收入" align="center" ></el-table-column>-->
	  	<!--<el-table-column prop="origin_divide_income" label="流量主收入扣除分成" align="center" >
	  		<template slot-scope="scope">
			      <span class="red">{{scope.row.origin_divide_income}}</span>
			  </template>
	  	</el-table-column>-->
	  	<!--<el-table-column prop="matrix_income" label="矩阵互导分发" align="center" ></el-table-column>-->
	  	<!--<el-table-column prop="nonmatrix_income" label="矩阵对外分发" align="center" >
	  		<template slot-scope="scope">
			      <span class="red">{{scope.row.nonmatrix_income}}</span>
			  </template>
	  	</el-table-column>-->
	  	<!--<el-table-column prop="distribution_income" label="分发合计" align="center" ></el-table-column>
	  	<el-table-column prop="matrix_buy_cost" label="矩阵买量成本" align="center" ></el-table-column>-->
	  	<!--<el-table-column prop="matrix_each_cost" label="矩阵互导成本" align="center" ></el-table-column>-->
	  	<!--<el-table-column prop="total_cost" label="成本合计" align="center" ></el-table-column>
	    <el-table-column  prop="total_matrix_income" label="矩阵实际收入" align="center" ></el-table-column>
	  	<el-table-column  prop="matrix_flow_income" label="矩阵流水收入" align="center" ></el-table-column>
	  	<el-table-column  prop="day_profit" label="日利润" align="center" ></el-table-column>-->
    </el-table>

    <!--<el-pagination
      class="pagination"
      @size-change="SizeChange"
      @current-change="CurrentChange"
      :current-page.sync="pdata.page"
      :page-sizes="[20, 40, 60, 80]"
      :page-size="pdata.perpage"
      background
      layout="sizes, prev, pager, next, jumper"
      :total="pdata.perpage*maxPage"
    ></el-pagination>-->
    
    <el-dialog title="导出选择" :visible.sync="checkDialog">
    	<el-row>
  			<el-col :span="24" style="margin: 10px 0;">
	    	  <el-checkbox :indeterminate="isIndeterminate" v-model="checkAll" @change="handleCheckAllChange">全选</el-checkbox>
	    	</el-col>
			</el-row>
			<el-row>
    	 	<el-checkbox-group v-model="checks" @change="handleCheckedChange">
    	 		<el-row>
	    	 		<el-col :span="6" v-for="item in checklist" style="margin: 10px 0;">
				    	<el-checkbox :label="item" :key="item.value">{{item.name}}</el-checkbox>
				    </el-col>
			    </el-row>
			  </el-checkbox-group>
			</el-row>  
			<el-row>
				<el-col :span="24">
					<el-button type="primary" @click="handleDownload">确定</el-button>
				</el-col>
			</el-row>
    </el-dialog>


  </section>
</template>

<script>
import $ from "jquery";
import { getIncomeDaily, getAppid,getValidProductPlatform } from "../../api/api";

export default {
  data() {
    return {
      chartColumn: null,
      pholder: "",
      pdata: {
      	platform_id:1,
        page: 1,
        perpage: 20,
        issued_app_id: "",
        kw: "",
        sdate: new Date(new Date().getTime() - 3600 * 1000 * 7 * 24)
          .toISOString()
          .slice(0, 10),
        edate: new Date(new Date().getTime() - 3600 * 1000 * 24)
          .toISOString()
          .slice(0, 10)
        // sdate: "2019-04-15",
        // edate: "2019-04-15",
      },
      tText: "请选择创意类型",
      plist: [],
      maxPage: 1,
      config: [],
      editDialog: false,
      checkDialog: false,
      checklist: [
	      {"name":"日期",value:"d_date" },
				{"name":"换入量",value:"huanliang_in"  },
				{"name":"换出量",value:"huanliang_out" },
				{"name":"矩阵买量",value:"matrix_buy_cost" },
				{"name":"矩阵卖量",value:"matrix_sell_income" },
				{"name":"流量主",value:"origin_income" },
				{"name":"流量主分成",value:"origin_divide_income" },
				{"name":"渠道买量",value:"channel_buy_cost" },
				{"name":"渠道卖量",value:"channel_sell_income" },
				{"name":"广点通",value:"gdt_buy_cost" },
				{"name":"收入（含矩阵）",value:"total_income_contain_matrix"},
				{"name":"成本（含矩阵）",value:"total_cost_contain_matrix" },
				{"name":"利润（含矩阵）",value:"total_profit_contain_matrix" },
				{"name":"收入（不含矩阵）",value:"total_income_no_matrix" },
				{"name":"成本（不含矩阵）",value:"total_cost_no_matrix" },
				{"name":"利润（不含矩阵）",value:"total_profit_no_matrix"}
			],
			checks:[],
			isIndeterminate: false,
			checkAll: false,
      group: {},

      dateVal: [
        new Date(new Date().getTime() - 3600 * 1000 * 7 * 24)
          .toISOString()
          .slice(0, 10),
        new Date(new Date().getTime() - 3600 * 1000 * 24)
          .toISOString()
          .slice(0, 10)
      ],
      pickerOptions: {
        shortcuts: [
          {
            text: "昨天",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24);
              picker.$emit("pick", [start, start]);
            }
          },
          {
            text: "最近一周",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 6);
              picker.$emit("pick", [start, end]);
            }
          },
          {
            text: "最近一个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit("pick", [start, end]);
            }
          },
          {
            text: "最近三个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit("pick", [start, end]);
            }
          }
        ]
      },
      list:[], //所有数据
      loading:false,
      height:710,
      get_issued_app_platform: [],
    };
  },
  watch: {
    dateVal: {
      handler(n, o) {
        if (n[0]) {
          this.pdata.sdate = n[0];
          this.pdata.edate = n[1];
          this.getList();
        }
      },
      deep: true
    }
  },
  methods: {
  	changePlatform(){
				this.getList();
		},
  	getPlatFormList(){
  		var p = "";
  		getValidProductPlatform(p, this.$cookie.getCookie("login")).then(res=>{
 
  			if(res.code == 200) {
					this.get_issued_app_platform = res.data;
				}
  		})
				
  	},
  	handleCheckAllChange (val) {
  		this.checks = val ? this.checklist : [];
      this.isIndeterminate = false;
  	},
  	handleCheckedChange (value) {
  		
  		  let checkedCount = value.length;
        this.checkAll = checkedCount === this.checklist.length;
        this.isIndeterminate = checkedCount > 0 && checkedCount < this.checklist.length;
        this.checks = value;
  	},
  	exportIncome () {
  		if(this.loading==true){
  				 this.$message({ message: "暂时无法导出，请稍后！", type: "warning" });
  				return false;
  		}
  		else{
  			this.checkDialog = true
  		}
  	},
  	  	//数据导出
    handleDownload() {
      var that = this;
      var arr = [];
      var arrHd =this.checks.map((v,i)=>{ return v.name})
      var arrFval =this.checks.map((v,i)=>{ return v.value})
//    if (that.tablelistAll.length > 0) {
//      that.exclelist = arr.concat(that.tablelistAll);
//    } else {
//      that.exclelist = arr.concat(that.tablelist);
//      arrHd = arrHd.splice(1);
//      arrFval = arrFval.splice(1);
//    }

      if (that.List == "") {
        return false;
      }

      console.log(arrHd);
      console.log(arrFval);
      require.ensure([], () => {
        const {
          export_json_to_excel,
          export_table_to_excel
        } = require("../../vendor/Export2Excel.js");
        const tHeader = arrHd;
        const filterVal = arrFval;
        const list = this.list;

        const data = this.formatJson(filterVal, list);
        
        export_json_to_excel(
          tHeader,
          data,
          this.pdata.sdate+'~'+this.pdata.edate+"收入日报"
        );
//      export_table_to_excel("ta");
      });
    },
    formatJson(filterVal, jsonData) {
      return jsonData.map(v => filterVal.map(j => v[j]));
    },
  	getHeaderCellClassName({row, column, rowIndex, columnIndex}){
  	
  		if(columnIndex==11||columnIndex==14){return 'thRed';}
  		
  	},
  	cellClassName({row, column, rowIndex, columnIndex}){
  		 console.log(column.label,columnIndex)
		   if(columnIndex == 12||columnIndex==15){
          return 'cellRed'
      }
  	},
  	getSummaries(param) {
	    const { columns, data } = param;
	    const sums = [];
	    columns.forEach((column, index) => {
	      if (index === 0) {
	        sums[index] = '合计';
	        return;
	      }
	      const values = data.map(item => Number(item[column.property]));
	      if (!values.every(value => isNaN(value))) {
	        sums[index] ='￥'+  values.reduce((prev, curr) => {
	          const value = Number(curr);
	          if (!isNaN(value)) {
	            return prev + curr;
	          } else {
	            return prev;
	          }
	        }, 0).toFixed(2);
	      } else {
	        sums[index] = 'N/A';
	      }
	    });
	
	    return sums;
	  },
    getList() {
    	this.loading=true;
      var p = "";
      for (var k in this.pdata) {
        // if (this.pdata[k]) p += "&" + k + "=" + this.pdata[k];
        if (this.pdata[k]) p += k + "=" + this.pdata[k] + "&";
      }
      getIncomeDaily(p, this.$cookie.getCookie("login")).then(res => {
      	this.loading=false;
        if (res.code == 200) {
          // "总访问人数", "总新增访问人数", "总收入","利润","买量成本","ROI"
          if(res.data.list&&res.data.list.length>0){
          	this.list=res.data.list
          }
          else{
          		this.list=[];
          }
          
          
        }
      });
    },
    SizeChange(v) {
      this.pdata.perpage = v;
      this.getList();
    },
    CurrentChange(v) {
      this.pdata.page = v;
      this.getList();
    },
    changeDate(s) {
      this.dateVal = [
        new Date(new Date().getTime() - 3600 * 1000 * 24 * s)
          .toISOString()
          .slice(0, 10),
        new Date(new Date().getTime() - 3600 * 1000 * 24)
          .toISOString()
          .slice(0, 10)
      ];
      // this.getList();
    },
    changeId(res) {
      this.pdata.issued_app_id = res;
      this.getList();
    }
  },
  
    created(){
  	
  	console.log($(window).height()-200);
  	this.height=$(window).height()-200
  },

  mounted() {

    if (Object.keys(this.$route.params).length > 0) {
      this.pdata.sdate = this.$route.params.sdate;
      this.pdata.edate = this.$route.params.edate;
      this.pdata.app_id = this.$route.params.app_id;
      this.pholder = this.$route.params.name;
    }
    this.getPlatFormList();
    this.getList();
  }
};
</script>

<style lang="scss">
.el-button + .el-button {
  margin-left: 0;
}
#chart > div {
  margin: 0 auto;
}
.cellRed,.thRed{ background: #FFFF00 !important;}
</style>


<style scoped="scoped">
	.red{
		color: #FF0000;
	}
</style>


// WEBPACK FOOTER //
// incomeDaily.vue?25eeecc7